import ConditionPanel from 'shared-assets/billing-profiles-ui/components/patient-case-condition/Condition';

angular
  .module('kareo.ui.shared.directives.k-patient-condition', [
    'react'
  ])
  .directive('kPatientCondition', kPatientCondition);
  

function kPatientCondition(reactDirective) {
    return reactDirective(ConditionPanel);
}

kPatientCondition.$inject = ['reactDirective'];
